import { Suspense, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "application/store/reducers/rootReducer";
import Loader from "ui/components/atoms/loaderModal/Loader";
import LoaderModal from "ui/components/atoms/loaderModal";
import GlobalModalContainer from "ui/components/molecules/GlobalModalContainer";
import CheckpointStatusR from "ui/components/molecules/CheckpointStatus/CheckpointStatusR";
import { TrackerService } from "infrastructure/services/tracker/tracker.service";
import { navigateRef } from "infrastructure/api";
import Routes from "./routes/IndexRouter";
import { CheckpointInjector } from "infrastructure/services/checkpoint/checkpoint.injector";
import { useSetUtmTags } from "infrastructure/services/tracker/utm-tag-hook";

if (window.location.href.indexOf('DEBUGMODE=true') > -1) {
  window.debugMode = true;
}

TrackerService.initialize();

const CheckpointComponent = CheckpointStatusR;

export default function App() {

  useSetUtmTags();

  const { hasToken } = useSelector((state: RootState) => ({
    hasToken: state.TokenState,
  }));

  const navigate = useNavigate();

  useEffect(() => {
    navigateRef.current = navigate;

    return () => {
      navigateRef.current = null;
    };
  }, [navigate]);


  return (
    <>
      <LoaderModal />
      <GlobalModalContainer />
      {hasToken && <CheckpointComponent />}
      {hasToken && <CheckpointInjector />}
      <Suspense fallback={<Loader isLoading />}>
        <Routes />
      </Suspense>
    </>
  );
}